/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetHlsClipPlaylistQueryResponse, SegmentsGetHlsClipPlaylistPathParams, SegmentsGetHlsClipPlaylistQueryParams, SegmentsGetHlsClipPlaylist400, SegmentsGetHlsClipPlaylist401, SegmentsGetHlsClipPlaylist403, SegmentsGetHlsClipPlaylist404 } from "../models/SegmentsGetHlsClipPlaylist";

export function getSegmentsGetHlsClipPlaylistUrl(station: SegmentsGetHlsClipPlaylistPathParams["station"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/hls-clip` as const }
  return res
}

/**
 * @description Returns an HLS media playlist (M3U8) covering only the requested interval. Fully covered middle segments keep original media URLs. Partial first/last MPEG-TS files point at the export stream-copy trim endpoint, authenticated with the same `access_token` query parameter used on this request. fMP4 stations are not supported. Pass `access_token` on the URL (Traefik strips Authorization before this API).
 * @summary Get a clipped VOD HLS playlist for a time range
 * {@link /segments/v1/stations/:station/hls-clip}
 */
export async function segmentsGetHlsClipPlaylist(station: SegmentsGetHlsClipPlaylistPathParams["station"], params: SegmentsGetHlsClipPlaylistQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetHlsClipPlaylistQueryResponse, ResponseErrorConfig<SegmentsGetHlsClipPlaylist400 | SegmentsGetHlsClipPlaylist401 | SegmentsGetHlsClipPlaylist403 | SegmentsGetHlsClipPlaylist404>, unknown>({ method : "GET", url : getSegmentsGetHlsClipPlaylistUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}